import { z } from 'zod';
/** Abfrageparameter der FIAP-Antragsexporte. */
export const fiapExportQuerySchema = z.object({
    /** Entscheidungsdatum ab (einschließlich). */
    from: z.iso.date().optional(),
    /** Entscheidungsdatum bis (einschließlich). */
    to: z.iso.date().optional(),
    /** `false` schaltet die Obergrenze von 10 Einträgen je Werk ab (Standard: an). */
    cap: z.enum(['true', 'false']).default('true'),
});
/** Zeile des Antrags („page C"), Spalten A–G. */
export const fiapRowSchema = z.object({
    accNo: z.number().int(),
    titleNo: z.number().int(),
    title: z.string(),
    salon: z.string(),
    country: z.string(),
    fiapNumber: z.string(),
    award: z.string(),
});
/** Vorschau des Antrags: Zeilen, Warnungen und wegen der Obergrenze weggelassene Einträge. */
export const fiapPreviewSchema = z.object({
    rows: z.array(fiapRowSchema),
    warnings: z.array(z.object({
        label: z.string(),
        problem: z.enum(['missing_country', 'missing_fiap_number']),
    })),
    /** Wegen der Obergrenze nicht gelistete Erfolge. */
    dropped: z.array(z.object({ title: z.string(), salon: z.string(), fiapNumber: z.string().nullable() })),
    /** Zeilenkapazität des Formulars. */
    capacity: z.number().int(),
    /** Ob mehr Zeilen anfallen, als das Formular aufnimmt. */
    exceedsCapacity: z.boolean(),
});
//# sourceMappingURL=exports.js.map